import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['year', 'month', 'day']

  static values = { defaultYear: String }
  connect() {
    const self = this
    this.yearTarget.addEventListener('mousedown', (event) => {
      if (event.target.value === '') {
        event.target.value = self.defaultYearValue
      }
    })
  }

  monthChange(event) {
    const monthSelected = event.target.value
    this.dayTarget.querySelectorAll('option').forEach((option) => {
      option.classList.remove('hidden')
    })
    switch (monthSelected) {
      case '2': {
        let noDays = 0
        if (this.yearTarget.value && parseInt(this.yearTarget.value) % 4 === 0) {
          noDays = 29
        } else {
          noDays = 28
          this.dayTarget.querySelector("option[value='29']").classList.add('hidden')
        }

        this.dayTarget.querySelector("option[value='30']").classList.add('hidden')
        this.dayTarget.querySelector("option[value='31']").classList.add('hidden')
        if (parseInt(this.dayTarget.value) > noDays) {
          this.dayTarget.value = ''
        }
        break
      }
      case '4':
      case '6':
      case '9':
      case '11':
        this.dayTarget.querySelector("option[value='31']").classList.add('hidden')
        if (parseInt(this.dayTarget.value) > 30) {
          this.dayTarget.value = ''
        }
        break
      default:
    }
  }

  yearChange(event) {
    const yearSelected = event.target.value
    const monthSelected = this.monthTarget.value

    if (monthSelected && parseInt(yearSelected) % 4 === 0 && monthSelected === '2') {
      this.dayTarget.querySelector("option[value='29']").classList.remove('hidden')
    } else {
      this.dayTarget.querySelector("option[value='29']").classList.add('hidden')
      if (parseInt(this.dayTarget.value) > 28) {
        this.dayTarget.value = ''
      }
    }
  }
}
